var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout-diagnostico a11y-simplificada-block"},[_c('MapaDiagnostico'),_c('FichasParaMapa',{staticClass:"fichas",attrs:{"data-section":"fichas"}}),_c('PieComponenteLibreria',{staticClass:"pie-en-diagnostico"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }